import { storageProvider } from '@ocean/configs'

const EVENT_NOTIFICATIONS_VIEWED = 'EVENT_NOTIFICATIONS_VIEWED'

// Event Notifications for page refresh and direct links
class EventNotificationsUtils {
  viewed = 'VIEWED'

  markEventNotificationsViewed() {
    storageProvider.setItem(EVENT_NOTIFICATIONS_VIEWED, this.viewed)
  }

  clearEventNotificationsViewed() {
    storageProvider.removeItem(EVENT_NOTIFICATIONS_VIEWED)
  }

  getEventNotificationsState() {
    return storageProvider.getItem(EVENT_NOTIFICATIONS_VIEWED)
  }
}

export default new EventNotificationsUtils()
